.numberTableValue {
  height: 100%;
  font-family: var(--font-roboto-mono);
  text-align: right;
}
